/* Birth Profile Analyst — review collection (button + modal + moderated form).
   Adds a "Laat een review achter" button under the homepage testimonials.
   Submissions go through Web3Forms (same service as the contact page), so they
   arrive by e-mail. A review only appears on the site after it is manually
   approved and added as a tile. */
(function () {
  var ACCESS_KEY = 'c103a27d-608f-432c-bc91-28253d1b8eb1';

  function init() {
    var grid = document.querySelector('.voices .voice-grid');
    if (!grid || document.getElementById('rvcOpen')) return;
    var container = grid.parentNode;

    var st = document.createElement('style');
    st.textContent = [
      '.rvc-wrap{text-align:center;margin-top:50px}',
      '.rvc-note{font-family:var(--sans);font-size:12.5px;line-height:1.6;color:var(--ink-dim);margin:16px auto 0;max-width:430px}',
      '.rvc-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px}',
      '.rvc-modal[hidden]{display:none}',
      '.rvc-backdrop{position:absolute;inset:0;background:rgba(4,10,26,.80);backdrop-filter:blur(5px)}',
      '.rvc-dialog{position:relative;z-index:1;width:100%;max-width:520px;max-height:90vh;overflow:auto;background:linear-gradient(160deg,var(--bg-2),var(--bg));border:1px solid var(--gold);padding:40px 34px 34px;box-shadow:0 30px 80px rgba(0,0,0,.6)}',
      '.rvc-x{position:absolute;top:10px;right:16px;background:none;border:0;color:var(--ink-dim);font-size:28px;line-height:1;cursor:pointer;transition:color .2s}',
      '.rvc-x:hover{color:var(--cream)}',
      '.rvc-eyebrow{font-family:var(--mono);font-size:10px;letter-spacing:.45em;text-transform:uppercase;color:var(--gold);margin-bottom:12px}',
      '.rvc-dialog h3{font-family:var(--serif);font-weight:500;font-size:28px;color:var(--cream);margin:0 0 24px}',
      '.rvc-form label{display:block;margin-bottom:16px}',
      '.rvc-form label span{display:block;font-family:var(--mono);font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:var(--ink-dim);margin-bottom:7px}',
      '.rvc-form input,.rvc-form select,.rvc-form textarea{width:100%;background:rgba(8,18,42,.6);border:1px solid var(--line);color:var(--cream);padding:12px 14px;font-family:var(--sans);font-size:14px;border-radius:0;-webkit-appearance:none;appearance:none}',
      '.rvc-form input:focus,.rvc-form select:focus,.rvc-form textarea:focus{border-color:var(--gold);outline:none}',
      '.rvc-form textarea{resize:vertical;line-height:1.6}',
      '.rvc-form .btn{width:100%;justify-content:center;margin-top:6px}',
      '.rvc-success{font-family:var(--sans);font-size:15px;line-height:1.75;color:var(--gold-2)}',
      '.rvc-fine{font-family:var(--sans);font-size:11px;line-height:1.5;color:var(--ink-dim);text-align:center;margin-top:14px}',
      '.rvc-err{font-family:var(--sans);font-size:13px;color:#e7948c;text-align:center;margin-top:12px;display:none}'
    ].join('');
    document.head.appendChild(st);

    var wrap = document.createElement('div');
    wrap.className = 'rvc-wrap reveal in';
    wrap.innerHTML =
      '<button type="button" class="btn rvc-open" id="rvcOpen" aria-haspopup="dialog">Laat een review achter <span class="arrow">→</span></button>' +
      '<p class="rvc-note">Reviews worden eerst door ons gelezen en goedgekeurd voordat ze op de site verschijnen.</p>';
    container.insertBefore(wrap, grid.nextSibling);

    var modal = document.createElement('div');
    modal.className = 'rvc-modal';
    modal.id = 'rvcModal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="rvc-backdrop" data-rvc-close></div>' +
      '<div class="rvc-dialog">' +
        '<button type="button" class="rvc-x" data-rvc-close aria-label="Sluiten">×</button>' +
        '<div class="rvc-eyebrow">Jouw ervaring</div>' +
        '<h3>Laat een review achter</h3>' +
        '<form class="rvc-form" id="rvcForm" novalidate>' +
          '<label><span>Naam</span><input type="text" id="rvcName" required></label>' +
          '<label><span>E-mailadres</span><input type="email" id="rvcMail" required></label>' +
          '<label><span>Beoordeling</span><select id="rvcRating" required>' +
            '<option value="">Kies een score…</option>' +
            '<option value="★★★★★ (5)">★★★★★ (5)</option>' +
            '<option value="★★★★ (4)">★★★★ (4)</option>' +
            '<option value="★★★ (3)">★★★ (3)</option>' +
            '<option value="★★ (2)">★★ (2)</option>' +
            '<option value="★ (1)">★ (1)</option>' +
          '</select></label>' +
          '<label><span>Je review</span><textarea id="rvcBody" rows="5" required></textarea></label>' +
          '<button type="submit" class="btn" id="rvcSubmit">Review versturen <span class="arrow">→</span></button>' +
          '<p class="rvc-fine">Je review wordt eerst door ons gelezen en pas na goedkeuring geplaatst.</p>' +
          '<p class="rvc-err" id="rvcErr">Er ging iets mis. Controleer je gegevens en probeer het opnieuw.</p>' +
        '</form>' +
        '<div class="rvc-success" id="rvcOk" style="display:none">Bedankt voor je review! We lezen hem eerst na en plaatsen hem na goedkeuring op de site.</div>' +
      '</div>';
    container.insertBefore(modal, wrap.nextSibling);

    function op() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function cl() { modal.hidden = true; document.documentElement.style.overflow = ''; }
    document.getElementById('rvcOpen').addEventListener('click', op);
    modal.addEventListener('click', function (e) { if (e.target.hasAttribute('data-rvc-close')) cl(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cl(); });

    var form = document.getElementById('rvcForm');
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var name = document.getElementById('rvcName').value.trim();
      var mail = document.getElementById('rvcMail').value.trim();
      var rating = document.getElementById('rvcRating').value;
      var body = document.getElementById('rvcBody').value.trim();
      var err = document.getElementById('rvcErr');
      if (!name || !mail || !rating || !body) { err.style.display = 'block'; return; }
      err.style.display = 'none';
      var btn = document.getElementById('rvcSubmit');
      btn.style.pointerEvents = 'none';
      btn.textContent = 'Versturen…';
      var payload = {
        access_key: ACCESS_KEY,
        subject: 'Nieuwe website review — Birth Profile Analyst',
        from_name: 'Birth Profile Analyst — Review',
        replyto: mail,
        'Naam': name,
        'E-mail': mail,
        'Beoordeling': rating,
        'Review': body
      };
      try {
        var r = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var ok = false;
        try { ok = (await r.json()).success; } catch (e2) { ok = r.ok; }
        if (!ok) throw new Error('failed');
        form.style.display = 'none';
        document.getElementById('rvcOk').style.display = 'block';
      } catch (e3) {
        err.style.display = 'block';
        btn.style.pointerEvents = '';
        btn.textContent = 'Review versturen ';
        var ar = document.createElement('span'); ar.className = 'arrow'; ar.textContent = '→';
        btn.appendChild(ar);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
